import axios from 'axios';

import { ApiError } from '@/api/http';
import { readMessageFromData } from '@/utils/apiErrorMessage';

export function getApiErrorMessage(error: unknown, fallback?: string): string {
  if (error instanceof ApiError) {
    const fromData = readMessageFromData(error.data);
    if (fromData) return fromData;
    return error.message;
  }

  if (axios.isAxiosError(error)) {
    const fromData = readMessageFromData(error.response?.data);
    if (fromData) return fromData;
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  return fallback ?? 'Unknown error';
}
